function getUsersGeoPositionFromStorage() {
    const position = localStorage.getItem("position");
    return (typeof position === 'string') ?
         JSON.parse(position) : null;
}

function getUsersGeoPosition()
{
    console.warn('getUsersGeoPosition()');
    if (! navigator.geolocation) {
        console.warn('Geolocation is not supported');
    } else {
        localStorage.clear();
        // console.log('locating ...');
        const options = {enableHighAccuracy: true, maximumAge: 10000};
         navigator.geolocation.getCurrentPosition(
            getUsersGeoPosition__success,
            getUsersGeoPosition__error, options
        );
    }

    // return geoPosition;
}

function calcDistance (lat1, lon1, lat2, lon2, unit)
{
    if (lat1 == lat2 && lon1 == lon2) {
        return 0;
    }
    else {
        const radlat1 = Math.PI * lat1/180;
        const radlat2 = Math.PI * lat2/180;
        const theta = lon1-lon2;
        const radtheta = Math.PI * theta/180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit==="K") { dist = dist * 1.609344 }
        if (unit==="N") { dist = dist * 0.8684 }

        return parseInt(dist);
    }
}

function sortRetailerList(retailerList, sortBy, order, lat, lng)
{
    let results = retailerList;

    if (sortBy === 'distance' && lat && lng) {
        results.map((retailer) => {
            retailer.distance = 0;
            if (typeof retailer.position === 'object' && retailer.position !== null) {
                retailer.distance = calcDistance(lat, lng, retailer.position.lat, retailer.position.lng, "K");
            }

            return retailer;
        });

        results.sort((a, b) => (a.distance > b.distance) ? 1 : -1)
        // sort by name
    } else if (sortBy === 'name' && order === 'asc') {
        results.sort((a, b) => (a.name > b.name) ? 1 : -1)
    } else if (sortBy === 'name' && order === 'desc') {
        results.sort((a, b) => (a.name < b.name) ? 1 : -1)
    }

    return results;
}


function getUsersGeoPosition__success(position)
{
    console.log('getUsersGeoPosition__success()')

    const geoPosition = {
        lat : null,
        lng : null,
    };

    geoPosition.lat = parseFloat(position.coords.latitude.toFixed(2));
    geoPosition.lng = parseFloat(position.coords.longitude.toFixed(2));

    localStorage.setItem("position", JSON.stringify(geoPosition));
}

function getUsersGeoPosition__error()
{
    console.warn('geo position not allowed');
}


export {getUsersGeoPosition, getUsersGeoPositionFromStorage, calcDistance, sortRetailerList};